(function () {
	'use strict';

	// ─── Reveal on scroll ───────────────────────────────────────────────────────
	// Elements with the "reveal" class (Elementor global class) or data-reveal get
	// .is-revealed when they enter the viewport. data-reveal="stagger" delays its
	// children by 80 ms each, at most 5 steps (motion spec 02). The hidden state
	// only applies under html.arelis-motion (see _reveal.scss).

	var STEP = 80;
	var MAX_STEPS = 4;

	function prepare(el) {
		if (el.getAttribute('data-reveal') === 'stagger') {
			Array.prototype.forEach.call(el.children, function (child, i) {
				child.style.setProperty('--reveal-delay', Math.min(i, MAX_STEPS) * STEP + 'ms');
			});
		}
	}

	function revealAll(elements) {
		elements.forEach(function (el) {
			el.classList.add('is-revealed');
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		if (!document.documentElement.classList.contains('arelis-motion')) {
			return;
		}

		var elements = Array.prototype.slice.call(document.querySelectorAll('.reveal, [data-reveal]'));
		elements.forEach(prepare);

		if (!('IntersectionObserver' in window)) {
			revealAll(elements);
			return;
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-revealed');
					observer.unobserve(entry.target);
				}
			});
		}, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

		elements.forEach(function (el) {
			observer.observe(el);
		});
	});

})();
